import React, { useEffect, useState } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { IconButton } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import "./subAdminStyle.css";
import { Input } from "../../components/Form";
import { Button } from "../../components/Button/Button";
import { rights } from "./roles";
import { subAdminDetailApi } from "../../services/subAdmin";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { toastMessage } from "../../utils/toastMessage";

const ViewSubadmin = () => {
  const [inputField, setInputField] = useState({});
  const [subAdminRights, setSubAdminRights] = useState(rights);
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const { subAdminId } = useParams();

  const viewSubadminDetailsHandler = async () => {
    try {
      showLoader(true);
      const { data } = await subAdminDetailApi({
        subAdminId: subAdminId,
      });
      if (data?.code === 200) {
        toastMessage(data?.message, "success", "viewSubAdmin");
        setInputField(data?.result);
      } else {
        toastMessage(data?.message, "error", "viewSubAdmin");
      }
    } catch (e) {
      console.log(e.message);
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    console.log(subAdminId);
    viewSubadminDetailsHandler();
  }, []);

  return (
    <div className="WrapperArea">
      {loader}
      <div className="WrapperBox">
        <div className="TitleBox">
          <div className="user_detail_heading">
            <Link className="back_icon" to={-1}>
              <IconButton>
                <ArrowBackIosNewIcon className="back_button" />
              </IconButton>
            </Link>
            <h4 className="Title">View Sub-Admin Management</h4>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            {/* name */}
            <div className="form-group mb-2">
              <Input
                type="text"
                name="name"
                value={inputField?.name || ""}
                required
                placeholder="Enter  Name"
                className={`form-control `}
                label={"Name"}
                maxLength={30}
                disabled
              />
            </div>
          </div>
          <div className="col-6">
            {/* name */}
            <div className="form-group mb-2">
              <Input
                type="text"
                name="email"
                value={inputField?.email || ""}
                required
                placeholder="Enter Email"
                className={`form-control `}
                label={"Email"}
                maxLength={30}
                disabled
              />
            </div>
          </div>
          {/* User Name */}
          <div className="col-6">
            <div className="form-group mb-2">
              <Input
                type="text"
                name="role"
                value={inputField?.role || ""}
                required
                placeholder="Enter Role"
                className={`form-control `}
                maxLength={30}
                disabled
              />
            </div>
          </div>
          {/* Email */}
          {/* <div className="col-6">
            <div className="form-group mb-2">
              <Input
                type="text"
                name="password"
                value={inputField?.password || ""}
                required
                placeholder="Enter Password"
                className={`form-control `}
                label={"Password"}
              />
            </div>
          </div> */}
        </div>

        <div className="row my-4 ">
          {/* <div className="col-md-12"> */}
          <h5 className="form-label">Select Rights</h5>
          <div className="row">
            {rights.map((right, index) => (
              <div key={index} className="form-check col-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value={right?.value}
                  checked={
                    (inputField &&
                      inputField?.rights &&
                      inputField?.rights[right?.value]) ||
                    false
                  }
                  id={`right${index}`}
                  name={right?.name}
                  disabled
                />
                <label className="form-check-label" htmlFor={`right${index}`}>
                  {right?.name}
                </label>
              </div>
            ))}
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default ViewSubadmin;
